export default "__VITE_ASSET__D$N5ndxb__"